
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import Button from '../components/base/Button';
import SEO from '../components/SEO';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="404 - Side Ikke Fundet | EquiNord"
        description="Siden du leder efter findes ikke. Gå tilbage til forsiden eller udforsk kategorierne."
        robots="noindex, follow"
      />
      <Header />
      
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-9xl font-bold text-emerald-600 mb-4">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Siden blev ikke fundet
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Beklager, men siden du leder efter eksisterer ikke eller er blevet flyttet.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" onClick={() => navigate('/')}>
              Gå til Forsiden
            </Button>
            <Button variant="outline" size="lg" onClick={() => navigate(-1)}>
              Gå Tilbage
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-gray-600 mb-4">Måske leder du efter:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/sadler" className="text-emerald-600 hover:text-emerald-700 font-medium">
                Sadler
              </Link>
              <Link to="/ridebeklaedning" className="text-emerald-600 hover:text-emerald-700 font-medium">
                Ridebeklædning
              </Link>
              <Link to="/pleje" className="text-emerald-600 hover:text-emerald-700 font-medium">
                Plejeudstyr
              </Link>
              <Link to="/staldinventar" className="text-emerald-600 hover:text-emerald-700 font-medium">
                Staldinventar
              </Link>
              <Link to="/hestetilbehor" className="text-emerald-600 hover:text-emerald-700 font-medium">
                Hestetilbehør
              </Link>
              <Link to="/blog" className="text-emerald-600 hover:text-emerald-700 font-medium">
                Blog
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}